import {Button, Col, Form, Input, Row} from 'antd';
import {TranslationOutlined} from '@ant-design/icons';
import {RichTextEditor} from 'components/richTextEditor';
import styles from '../../subscriptionSettings.module.scss';

// `fieldName` is the Form.Item-relative path (prefixed automatically inside a
// Form.List); `watchName` is the absolute path used for useWatch and for the
// translate handler's getFieldValue/setFieldValue. They differ when this field
// lives inside a Form.List row.
const LocalizedTextField = ({
  label,
  fieldName,
  watchName,
  required = false,
  multiline = false,
  richText = false,
  onTranslate,
  loadingTranslation = false,
}) => {
  const englishValue = Form.useWatch([...watchName, 'EN']);
  const canTranslate = `${englishValue ?? ''}`.trim().length > 1;
  const rules = required
    ? [{required: true, message: `${label} is required!`}]
    : [];

  // Rich-text fields (e.g. the subtitle) render a Quill editor per locale to
  // mirror the announcement editor; plain fields stay as inputs/textareas.
  const renderField = locale => {
    if (richText) {
      return (
        <RichTextEditor
          className={styles['reminder-quill']}
          placeholder={`${label} in ${locale}`}
        />
      );
    }
    const FieldComponent = multiline ? Input.TextArea : Input;
    return (
      <FieldComponent
        rows={multiline ? 2 : undefined}
        placeholder={`${label} in ${locale}`}
      />
    );
  };

  return (
    <Row gutter={16} align="top">
      <Col xs={24} md={12}>
        <Form.Item
          label={`${label} (English)`}
          name={[...fieldName, 'EN']}
          rules={rules}
          style={{marginBottom: onTranslate ? 4 : undefined}}>
          {renderField('English')}
        </Form.Item>
        {onTranslate ? (
          <Button
            type="link"
            size="small"
            icon={<TranslationOutlined />}
            disabled={loadingTranslation || !canTranslate}
            onClick={() => onTranslate(watchName)}
            style={{paddingLeft: 0, marginBottom: 12}}>
            Translate from English
          </Button>
        ) : null}
      </Col>
      <Col xs={24} md={12}>
        <Form.Item label={`${label} (French)`} name={[...fieldName, 'FR']}>
          {renderField('French')}
        </Form.Item>
      </Col>
    </Row>
  );
};

export default LocalizedTextField;
